import { formatDate, MOMENT_FORMATS, toMoment } from '../../../utils/dateFormat';

export const parseTimelineDate = (value) => {
  const parsed = toMoment(value);
  return parsed ? parsed.toDate() : null;
};

export const formatTimelineTimestamp = (value) =>
  formatDate(value, MOMENT_FORMATS.DATETIME) || 'Pending';
